var _style, _defs, _rect, _rect2, _polygon, _rect3, _rect4, _rect5, _rect6, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 113.98",
    style: {
      enableBackground: "new 0 0 120 113.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#D4222A;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#E32787;}\r\n\t.st2{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#EEDD50;}\r\n\t.st3{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#90C145;}\r\n\t.st4{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#35A7DF;}\r\n\t.st5{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#202A50;}\r\n\t.st6{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#223B76;}\r\n\t.st7{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#18A34A;}\r\n\t.st8{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#1C5F33;}\r\n\t.st9{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#116EB4;}\r\n\t.st10{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#223874;}\r\n\t.st11{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#24254D;}\r\n\t.st12{fill:#010202;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "89.53,0 74.88,14.53 60,0 45.12,14.53 30.47,0 0,30 0.12,60.47 30.47,30 60,59.29 89.53,30  119.88,60.47 120,30  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -11.57,
    y: 30,
    className: "st0",
    width: 42.05,
    height: 35.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -11.57,
    y: -5.08,
    className: "st1",
    width: 42.05,
    height: 35.08
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "30.47,0 47.01,-6.38 45.12,14.53 30.47,30.35  "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.47,
    y: 30,
    className: "st3",
    width: 29.41,
    height: 29.41
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    className: "st4",
    width: 29.53,
    height: 29.29
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.53,
    y: 30,
    className: "st5",
    width: 37.8,
    height: 35.91
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.53,
    y: -5.79,
    className: "st6",
    width: 37.8,
    height: 35.79
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "60,0 45.12,14.53 60,30  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "30.47,30 60,30 45.24,14.53  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "89.53,0 72.99,-6.38 74.88,14.53 89.53,30.35  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "60,0 74.88,14.53 60,30  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "89.53,30 60,30 74.76,14.53  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M30.59,113.98L16.54,83.5h-2.13L0.24,113.98H2.6l3.9-8.5h17.83l3.78,8.5H30.59z M23.39,103.46H7.44 l7.91-17.48L23.39,103.46z M61.65,113.98l-9.92-12.99c1.18-0.12,2.36-0.47,3.43-0.83c1.18-0.47,2.13-1.06,2.83-1.77 c0.83-0.71,1.42-1.65,1.89-2.6c0.47-0.94,0.71-2.13,0.71-3.43l0,0c0-1.3-0.35-2.48-0.83-3.54c-0.47-1.06-1.18-2.01-2.13-2.72 c-0.94-0.71-2.13-1.3-3.43-1.77c-1.3-0.47-2.83-0.59-4.49-0.59H37.09v30.24h2.24v-12.52h9.8l9.69,12.52H61.65z M58.35,92.48 c0,1.06-0.24,2.01-0.71,2.95c-0.47,0.83-1.06,1.54-1.89,2.13c-0.71,0.59-1.65,1.06-2.72,1.42c-1.06,0.24-2.24,0.47-3.54,0.47H39.33 v-13.7h10.28c2.72,0,4.96,0.59,6.38,1.77c1.54,1.18,2.36,2.83,2.36,4.84V92.48z M89.06,85.75v-2.01H65.67v2.01H76.3v28.23h2.24 V85.75H89.06z M119.76,113.98L105.71,83.5h-2.24l-14.06,30.47h2.36l3.78-8.5h17.83l3.9,8.5H119.76z M112.44,103.46H96.5l8.03-17.48 L112.44,103.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArta);
export default __webpack_public_path__ + "static/media/ARTA.e2ee7f995eb45c88471b7a82b9bd9154.svg";
export { ForwardRef as ReactComponent };